// Auto-generated roaming country data from Excel spreadsheets

export interface MultinetEntry {
  country: string
  operator: string
  g3: boolean
  lte: boolean
  g5: boolean
}

export interface ZoneEntry {
  country: string
  network: string
  g2: boolean
  g3: boolean
  lte: boolean
  g5: boolean
}

export const multinetCountries: MultinetEntry[] = [
  { country: 'Austria', operator: 'A1 Telekom Austria AG', g3: true, lte: true, g5: true },
  { country: 'Austria', operator: '3 Austria', g3: true, lte: true, g5: false },
  { country: 'Belgium', operator: 'Proximus Belgium', g3: true, lte: true, g5: true },
  { country: 'Belgium', operator: 'ORANGE Belgium NV/SA', g3: true, lte: true, g5: true },
  { country: 'Belgium', operator: 'Telenet Group NV/SA', g3: true, lte: true, g5: false },
  { country: 'Bulgaria', operator: 'A1 Bulgaria', g3: true, lte: true, g5: true },
  { country: 'Bulgaria', operator: 'Vivacom Bulgaria', g3: true, lte: true, g5: false },
  { country: 'Bulgaria', operator: 'Yettel Bulgaria EAD', g3: true, lte: true, g5: false },
  { country: 'Croatia', operator: 'Hrvatski Telekom', g3: true, lte: true, g5: false },
  { country: 'Croatia', operator: 'Telemach Croatia Ltd.', g3: true, lte: true, g5: true },
  { country: 'Croatia', operator: 'A1 Hrvatska d.o.o', g3: true, lte: true, g5: true },
  { country: 'Cyprus', operator: 'cyta', g3: true, lte: true, g5: false },
  { country: 'Cyprus', operator: 'Epic Cyprus', g3: true, lte: true, g5: true },
  { country: 'Czechia', operator: 'Vodafone Czech Republic', g3: false, lte: true, g5: false },
  { country: 'Denmark', operator: 'Nuuday A/S', g3: true, lte: true, g5: true },
  { country: 'Denmark', operator: 'Telenor Denmark', g3: false, lte: true, g5: false },
  { country: 'Denmark', operator: 'Telia Denmark', g3: false, lte: true, g5: true },
  { country: 'Estonia', operator: 'Telia Eesti AS', g3: true, lte: true, g5: true },
  { country: 'Estonia', operator: 'Elisa Eesti AS', g3: false, lte: true, g5: false },
  { country: 'Estonia', operator: 'Tele2 Eesti Aktsiaselts', g3: true, lte: true, g5: false },
  { country: 'Finland', operator: 'DNA Plc', g3: true, lte: true, g5: false },
  { country: 'Finland', operator: 'Telia Finland Oyj', g3: true, lte: true, g5: true },
  { country: 'Germany', operator: 'Vodafone Germany', g3: false, lte: true, g5: false },
  { country: 'Germany', operator: 'Telekom Deutschland Gmbh', g3: false, lte: true, g5: true },
  { country: 'Germany', operator: 'Telefónica Germany GmbH & Co. OHG', g3: false, lte: true, g5: false },
  { country: 'Gibraltar', operator: 'Gibtelecom Limited', g3: true, lte: true, g5: false },
  { country: 'Greece', operator: 'Vodafone Greece', g3: true, lte: true, g5: false },
  { country: 'Hungary', operator: 'Yettel Magyarország Zártköruen Muködo Részvénytárs', g3: true, lte: true, g5: false },
  { country: 'Hungary', operator: 'Vodafone Hungary Ltd.', g3: true, lte: true, g5: false },
  { country: 'Ireland', operator: 'Vodafone Ireland', g3: true, lte: true, g5: false },
  { country: 'Ireland', operator: 'Eircom Limited', g3: true, lte: true, g5: false },
  { country: 'Italy', operator: 'TIM S.p.A', g3: true, lte: true, g5: false },
  { country: 'Italy', operator: 'Vodafone Italy', g3: true, lte: true, g5: false },
  { country: 'Italy', operator: 'ILIAD Italia S.p.A.', g3: true, lte: true, g5: false },
  { country: 'Italy', operator: 'Wind Telecomunicazioni SpA', g3: false, lte: true, g5: false },
  { country: 'Latvia', operator: 'Latvijas Mobilais Telefons', g3: true, lte: true, g5: false },
  { country: 'Latvia', operator: 'Tele2 SIA', g3: true, lte: true, g5: true },
  { country: 'Lithuania', operator: 'Telia Lietuva AB', g3: false, lte: true, g5: false },
  { country: 'Lithuania', operator: 'UAB Tele2', g3: true, lte: true, g5: false },
  { country: 'Luxembourg', operator: 'POST Luxembourg', g3: true, lte: true, g5: true },
  { country: 'Luxembourg', operator: 'Orange Luxembourg', g3: true, lte: true, g5: false },
  { country: 'Malta', operator: 'Epic Malta', g3: true, lte: true, g5: false },
  { country: 'Malta', operator: 'GO p.l.c.', g3: true, lte: true, g5: false },
  { country: 'Netherlands', operator: 'Vodafone Netherlands', g3: true, lte: true, g5: false },
  { country: 'Netherlands', operator: 'KPN B.V.', g3: true, lte: true, g5: false },
  { country: 'Norway', operator: 'Telenor Norway', g3: false, lte: true, g5: false },
  { country: 'Norway', operator: 'Telia Norge AS', g3: true, lte: true, g5: true },
  { country: 'Poland', operator: 'Orange Poland', g3: true, lte: true, g5: true },
  { country: 'Portugal', operator: 'Vodafone Portugal', g3: true, lte: true, g5: false },
  { country: 'Portugal', operator: 'NOS – Comunicações, S.A.', g3: true, lte: true, g5: false },
  { country: 'Romania', operator: 'Vodafone Romania', g3: true, lte: true, g5: false },
  { country: 'Romania', operator: 'Orange Romania', g3: true, lte: true, g5: true },
  { country: 'Slovakia', operator: 'Orange Slovakia', g3: true, lte: true, g5: false },
  { country: 'Slovakia', operator: 'O2 Slovakia', g3: true, lte: false, g5: false },
  { country: 'Slovenia', operator: 'A1 Slovenija, d.d.', g3: true, lte: true, g5: false },
  { country: 'Slovenia', operator: 'Telekom Slovenije d.d.', g3: true, lte: true, g5: true },
  { country: 'Spain', operator: 'Vodafone Spain', g3: true, lte: true, g5: false },
  { country: 'Spain', operator: 'Orange Spain', g3: true, lte: true, g5: true },
  { country: 'Spain', operator: 'Telefónica Móviles España', g3: true, lte: true, g5: false },
  { country: 'Sweden', operator: 'Telia Company AB', g3: true, lte: true, g5: true },
  { country: 'Sweden', operator: 'Telenor Sweden', g3: true, lte: true, g5: false },
  { country: 'United Kingdom', operator: 'Virgin Media O2', g3: true, lte: true, g5: true },
  { country: 'United Kingdom', operator: 'Vodafone United Kingdom', g3: true, lte: true, g5: false },
  { country: 'United Kingdom', operator: '3 United Kingdom', g3: true, lte: true, g5: false },
  { country: 'United Kingdom', operator: 'EE Limited', g3: true, lte: true, g5: true },
]

export const zone1Countries: ZoneEntry[] = [
  { country: 'Austria', network: '3 Austria', g2: false, g3: true, lte: true, g5: false },
  { country: 'Austria', network: 'A1 Telekom Austria AG', g2: false, g3: true, lte: true, g5: true },
  { country: 'Belgium', network: 'Telenet Group NV/SA', g2: false, g3: true, lte: true, g5: false },
  { country: 'Belgium', network: 'ORANGE Belgium NV/SA', g2: false, g3: true, lte: true, g5: true },
  { country: 'Belgium', network: 'Proximus Belgium', g2: false, g3: true, lte: true, g5: true },
  { country: 'Bulgaria', network: 'A1 Bulgaria', g2: false, g3: true, lte: true, g5: true },
  { country: 'Bulgaria', network: 'Yettel Bulgaria EAD', g2: false, g3: true, lte: true, g5: false },
  { country: 'Bulgaria', network: 'Vivacom Bulgaria', g2: false, g3: true, lte: true, g5: false },
  { country: 'Croatia', network: 'Hrvatski Telekom', g2: false, g3: true, lte: true, g5: false },
  { country: 'Croatia', network: 'Telemach Croatia Ltd.', g2: false, g3: true, lte: true, g5: true },
  { country: 'Croatia', network: 'A1 Hrvatska d.o.o', g2: false, g3: true, lte: true, g5: true },
  { country: 'Cyprus', network: 'cyta', g2: false, g3: true, lte: true, g5: false },
  { country: 'Cyprus', network: 'Epic Cyprus', g2: false, g3: true, lte: true, g5: true },
  { country: 'Czechia', network: 'Vodafone Czech Republic', g2: false, g3: false, lte: true, g5: false },
  { country: 'Denmark', network: 'Telenor Denmark', g2: false, g3: false, lte: true, g5: false },
  { country: 'Denmark', network: 'Telia Denmark', g2: false, g3: false, lte: true, g5: true },
  { country: 'Denmark', network: 'Nuuday A/S', g2: false, g3: true, lte: true, g5: true },
  { country: 'Estonia', network: 'Telia Eesti AS', g2: false, g3: true, lte: true, g5: true },
  { country: 'Estonia', network: 'Tele2 Eesti Aktsiaselts', g2: false, g3: true, lte: true, g5: false },
  { country: 'Estonia', network: 'Elisa Eesti AS', g2: false, g3: false, lte: true, g5: false },
  { country: 'Finland', network: 'DNA Plc', g2: false, g3: true, lte: true, g5: false },
  { country: 'Finland', network: 'Telia Finland Oyj', g2: false, g3: true, lte: true, g5: true },
  { country: 'Germany', network: 'Telekom Deutschland GmbH', g2: true, g3: false, lte: true, g5: true },
  { country: 'Germany', network: 'Vodafone Germany', g2: false, g3: false, lte: true, g5: false },
  { country: 'Germany', network: 'Telefónica Germany GmbH & Co. OHG', g2: false, g3: false, lte: true, g5: false },
  { country: 'Gibraltar', network: 'Gibtelecom Limited', g2: false, g3: true, lte: true, g5: false },
  { country: 'Greece', network: 'Vodafone Greece', g2: false, g3: true, lte: true, g5: false },
  { country: 'Hungary', network: 'Yettel Magyarország Zártköruen Muködo Részvénytárs', g2: false, g3: true, lte: true, g5: false },
  { country: 'Hungary', network: 'Vodafone Hungary Ltd.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Ireland', network: 'Vodafone Ireland', g2: false, g3: true, lte: true, g5: false },
  { country: 'Ireland', network: 'Eircom Limited', g2: false, g3: true, lte: true, g5: false },
  { country: 'Italy', network: 'ILIAD Italia S.p.A.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Italy', network: 'Vodafone Italy', g2: false, g3: true, lte: true, g5: false },
  { country: 'Italy', network: 'TIM S.p.A', g2: false, g3: true, lte: true, g5: false },
  { country: 'Italy', network: 'WINDTRE', g2: false, g3: false, lte: true, g5: false },
  { country: 'Latvia', network: 'Tele2 SIA', g2: false, g3: true, lte: true, g5: true },
  { country: 'Latvia', network: 'Latvijas Mobilais Telefons', g2: false, g3: true, lte: true, g5: false },
  { country: 'Lithuania', network: 'UAB Tele2', g2: false, g3: true, lte: true, g5: false },
  { country: 'Lithuania', network: 'Telia Lietuva AB', g2: false, g3: false, lte: true, g5: false },
  { country: 'Luxembourg', network: 'POST Luxembourg', g2: false, g3: true, lte: true, g5: true },
  { country: 'Luxembourg', network: 'Orange Luxembourg', g2: false, g3: true, lte: true, g5: false },
  { country: 'Malta', network: 'GO p.l.c.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Malta', network: 'Epic Malta', g2: false, g3: true, lte: true, g5: false },
  { country: 'Netherlands', network: 'Vodafone Netherlands', g2: false, g3: true, lte: true, g5: false },
  { country: 'Netherlands', network: 'KPN B.V.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Norway', network: 'Telia Norge AS', g2: false, g3: true, lte: true, g5: true },
  { country: 'Norway', network: 'Telenor Norway', g2: false, g3: false, lte: true, g5: false },
  { country: 'Poland', network: 'Orange Poland', g2: false, g3: true, lte: true, g5: true },
  { country: 'Portugal', network: 'NOS – Comunicações, S.A.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Portugal', network: 'Vodafone Portugal', g2: false, g3: true, lte: true, g5: false },
  { country: 'Romania', network: 'Vodafone Romania', g2: false, g3: true, lte: true, g5: false },
  { country: 'Romania', network: 'Orange Romania', g2: false, g3: true, lte: true, g5: true },
  { country: 'Slovakia', network: 'Orange Slovakia', g2: false, g3: true, lte: true, g5: false },
  { country: 'Slovakia', network: 'O2 Slovakia', g2: false, g3: true, lte: false, g5: false },
  { country: 'Slovenia', network: 'Telekom Slovenije d.d.', g2: false, g3: true, lte: true, g5: true },
  { country: 'Slovenia', network: 'A1 Slovenija, d.d.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Spain', network: 'Vodafone Spain', g2: false, g3: true, lte: true, g5: false },
  { country: 'Spain', network: 'Orange Spain', g2: false, g3: true, lte: true, g5: true },
  { country: 'Spain', network: 'Telefónica Móviles España', g2: false, g3: true, lte: true, g5: false },
  { country: 'Sweden', network: 'Telenor Sweden', g2: false, g3: true, lte: true, g5: false },
  { country: 'Sweden', network: 'Telia Company AB', g2: false, g3: true, lte: true, g5: true },
  { country: 'United Kingdom', network: 'Virgin Media O2', g2: false, g3: true, lte: true, g5: true },
  { country: 'United Kingdom', network: '3 United Kingdom', g2: false, g3: true, lte: true, g5: false },
  { country: 'United Kingdom', network: 'EE Limited', g2: false, g3: true, lte: true, g5: true },
  { country: 'United Kingdom', network: 'Vodafone United Kingdom', g2: false, g3: true, lte: true, g5: false },
]

export const zone2Countries: ZoneEntry[] = [
  { country: 'Algeria', network: 'Djezzy', g2: true, g3: true, lte: true, g5: false },
  { country: 'Andorra', network: 'Andorra Telecom', g2: false, g3: true, lte: true, g5: false },
  { country: 'Argentina', network: 'Claro Argentina', g2: false, g3: false, lte: true, g5: false },
  { country: 'Australia', network: 'SingTel Optus Pty Limited', g2: false, g3: true, lte: true, g5: true },
  { country: 'Bangladesh', network: 'Grameenphone Ltd', g2: true, g3: true, lte: true, g5: false },
  { country: 'Chile', network: 'Claro Chile', g2: false, g3: true, lte: true, g5: false },
  { country: 'China', network: 'China Unicom', g2: false, g3: true, lte: true, g5: true },
  { country: 'Colombia', network: 'Claro Colombia', g2: false, g3: true, lte: true, g5: false },
  { country: 'Costa Rica', network: 'Claro CR Telecomunicaciones, S.A.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Dominican Republic', network: 'Claro Dominican Republic', g2: false, g3: true, lte: true, g5: false },
  { country: 'Ecuador', network: 'Claro Ecuador', g2: false, g3: true, lte: true, g5: false },
  { country: 'El Salvador', network: 'CTE Telecom Personal, S.A. de C.V.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Faroe Islands', network: 'Nema', g2: true, g3: true, lte: true, g5: false },
  { country: 'Fiji', network: 'Digicel (Fiji) Ltd', g2: true, g3: true, lte: true, g5: false },
  { country: 'France', network: 'Orange France', g2: true, g3: true, lte: true, g5: true },
  { country: 'France', network: 'SFR', g2: true, g3: true, lte: true, g5: true },
  { country: 'France', network: 'Bouygues Télécom', g2: true, g3: true, lte: true, g5: false },
  { country: 'Guadeloupe', network: 'Outremer Télécom', g2: true, g3: true, lte: true, g5: false },
  { country: 'Guatemala', network: 'Telecomunicaciones de Guatemala S.A.', g2: true, g3: true, lte: true, g5: true },
  { country: 'Honduras', network: 'Servicios de Comunicaciones de Honduras S.A. de C.V.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Iceland', network: 'Vodafone Iceland', g2: true, g3: true, lte: true, g5: true },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Airtel India', g2: true, g3: false, lte: true, g5: false },
  { country: 'Indonesia', network: 'PT Telekomunikasi Selular', g2: true, g3: true, lte: true, g5: true },
  { country: 'Japan', network: 'KDDI Corporation', g2: false, g3: false, lte: true, g5: false },
  { country: 'Kazakhstan', network: 'Beeline Kazakhstan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Kyrgyzstan', network: 'Beeline Kyrgystan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Liechtenstein', network: 'Telecom Liechtenstein AG', g2: true, g3: true, lte: true, g5: true },
  { country: 'Liechtenstein', network: 'Salt Liechtenstein', g2: true, g3: true, lte: true, g5: false },
  { country: 'Macao, SAR China', network: 'CTM', g2: false, g3: true, lte: true, g5: true },
  { country: 'Mexico', network: 'Telcel', g2: true, g3: true, lte: true, g5: false },
  { country: 'Moldova, Republic of', network: 'Orange Moldova', g2: true, g3: true, lte: true, g5: false },
  { country: 'New Zealand', network: 'One NZ', g2: true, g3: true, lte: true, g5: true },
  { country: 'Nicaragua', network: 'EMPRESA NICARAGUENSE DE TELECOMUNICACIONES S.A.', g2: true, g3: true, lte: true, g5: false },
  { country: 'North Macedonia', network: 'A1 Makedonija DOOEL Skopje', g2: true, g3: true, lte: true, g5: false },
  { country: 'Oman', network: 'Omantel', g2: true, g3: true, lte: true, g5: true },
  { country: 'Oman', network: 'Vodafone Oman', g2: false, g3: false, lte: true, g5: true },
  { country: 'Pakistan', network: 'Telenor Pakistan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Paraguay', network: 'Claro Paraguay', g2: true, g3: true, lte: true, g5: false },
  { country: 'Peru', network: 'Claro Peru', g2: true, g3: true, lte: true, g5: false },
  { country: 'Philippines', network: 'Globe Telecom', g2: true, g3: true, lte: true, g5: true },
  { country: 'Puerto Rico', network: 'Claro Puerto Rico', g2: true, g3: true, lte: true, g5: false },
  { country: 'Réunion', network: 'Société Réunionnaise du Radiotéléphone', g2: true, g3: true, lte: true, g5: false },
  { country: 'Réunion', network: 'Orange La Reunion', g2: true, g3: true, lte: true, g5: false },
  { country: 'Réunion', network: 'TELCO OI', g2: true, g3: true, lte: false, g5: false },
  { country: 'Samoa', network: 'Digicel (Samoa) Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Serbia', network: 'A1 Serbia', g2: true, g3: true, lte: true, g5: false },
  { country: 'Singapore', network: 'Singtel', g2: false, g3: true, lte: true, g5: true },
  { country: 'Switzerland', network: 'Sunrise LLC', g2: false, g3: true, lte: true, g5: false },
  { country: 'Switzerland', network: 'Salt Switzerland', g2: false, g3: true, lte: true, g5: true },
  { country: 'Thailand', network: 'Advanced Wireless Network Company Limited', g2: false, g3: true, lte: true, g5: true },
  { country: 'Tonga', network: 'Digicel (Tonga) Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Turkey*', network: 'Vodafone Turkey', g2: true, g3: true, lte: true, g5: true },
  { country: 'Ukraine', network: 'lifecell LLC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Ukraine', network: 'Kyivstar, Private Joint Stock Company', g2: true, g3: true, lte: true, g5: false },
  { country: 'Ukraine', network: 'PrJSC VF Ukraine', g2: true, g3: true, lte: true, g5: false },
  { country: 'Uruguay', network: 'Claro Uruguay', g2: false, g3: true, lte: true, g5: false },
  { country: 'Vanuatu', network: 'Digicel (Vanuatu) Ltd', g2: true, g3: true, lte: true, g5: false },
]

export const zone3Countries: ZoneEntry[] = [
  { country: 'Australia', network: 'Telstra Limited', g2: false, g3: true, lte: true, g5: false },
  { country: 'Bosnia and Herzegovina', network: 'm:tel', g2: false, g3: true, lte: false, g5: false },
  { country: 'Bosnia and Herzegovina', network: 'BH Telecom JSC Sarajevo', g2: false, g3: true, lte: false, g5: false },
  { country: 'Cameroon', network: 'ORANGE CAMEROUN S.A.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Fiji', network: 'Vodafone Fiji', g2: true, g3: true, lte: true, g5: false },
  { country: 'France', network: 'Free Mobile', g2: true, g3: true, lte: true, g5: false },
  { country: 'Georgia', network: 'Cellfie Mobile LLC', g2: false, g3: true, lte: true, g5: false },
  { country: 'Guadeloupe', network: 'Dauphin Télécom', g2: true, g3: true, lte: true, g5: false },
  { country: 'Guadeloupe', network: 'Digicel Antilles Française Guyane', g2: true, g3: true, lte: true, g5: false },
  { country: 'Hong Kong, SAR China', network: 'Hutchison Telecommunications Hong Kong Holdings Limited', g2: false, g3: true, lte: true, g5: true },
  { country: 'Iceland', network: 'Síminn h.f.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Iceland', network: 'Nova ehf.', g2: true, g3: true, lte: false, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: false, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: false, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'India*', network: 'Vi', g2: true, g3: false, lte: true, g5: false },
  { country: 'Indonesia', network: 'PT. Hutchison 3 Indonesia', g2: true, g3: true, lte: false, g5: false },
  { country: 'Israel', network: 'Pelephone', g2: true, g3: true, lte: true, g5: true },
  { country: 'Japan', network: 'SoftBank Corp.', g2: false, g3: true, lte: true, g5: true },
  { country: 'Jordan', network: 'Zain Jordan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Korea, Republic of', network: 'SK Telecom Co., Ltd.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Korea, Republic of', network: 'KT Corporation', g2: false, g3: true, lte: true, g5: false },
  { country: 'Kosovo', network: 'IPKO', g2: true, g3: true, lte: true, g5: false },
  { country: 'Lesotho', network: 'Vodacom Lesotho (Pty) Ltd', g2: true, g3: true, lte: true, g5: false },
  { country: 'Malaysia', network: 'Celcom Axiata Berhad', g2: true, g3: false, lte: true, g5: true },
  { country: 'Martinique', network: 'FREE CARAïBE', g2: true, g3: true, lte: true, g5: false },
  { country: 'Mexico', network: 'AT&T Comercializacion Movil, S. de R.L. de C.V.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Moldova, Republic of', network: 'Moldcell S.A', g2: true, g3: true, lte: true, g5: false },
  { country: 'Moldova, Republic of', network: 'Moldtelecom S.A.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Montenegro', network: 'One', g2: true, g3: true, lte: true, g5: true },
  { country: 'Montenegro', network: 'MTEL d.o.o. Podgorica', g2: true, g3: true, lte: true, g5: false },
  { country: 'Mozambique', network: 'Vodacom Moçambique, S.A.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Myanmar', network: 'Myanma Posts and Telecommunications', g2: true, g3: true, lte: true, g5: false },
  { country: 'Nigeria', network: 'Globacom Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Nigeria', network: 'Emerging Markets Telecommunication Services Ltd', g2: true, g3: true, lte: true, g5: false },
  { country: 'Papua New Guinea', network: 'Digicel Papua New Guinea', g2: true, g3: true, lte: true, g5: false },
  { country: 'Russian Federation', network: 'MegaFon PJSC', g2: false, g3: true, lte: false, g5: false },
  { country: 'Russian Federation', network: 'Beeline Russia', g2: false, g3: true, lte: true, g5: false },
  { country: 'Serbia', network: 'Telekom Srbija a.d.', g2: true, g3: true, lte: true, g5: false },
  { country: 'South Africa', network: 'Vodacom (Pty) Ltd.', g2: true, g3: true, lte: true, g5: true },
  { country: 'Sri Lanka', network: 'Hutch Sri Lanka', g2: true, g3: true, lte: true, g5: false },
  { country: 'Tanzania, United Republic of', network: 'Vodacom Tanzania Limited', g2: true, g3: true, lte: true, g5: true },
  { country: 'Thailand', network: 'National Telecom Public Company Limited', g2: false, g3: true, lte: false, g5: false },
  { country: 'Thailand', network: 'True Move H Universal Communication Co., Ltd (THACA)', g2: true, g3: true, lte: true, g5: true },
  { country: 'Tonga', network: 'Tonga Communications Corporation', g2: true, g3: true, lte: true, g5: false },
  { country: 'Tunisia', network: 'Orange Tunisie, SA', g2: true, g3: true, lte: true, g5: false },
  { country: 'Tunisia', network: 'Tunisie Telecom', g2: true, g3: true, lte: true, g5: false },
  { country: 'Turkey*', network: 'Turkcell Iletisim Hizmetleri A.S.', g2: true, g3: true, lte: true, g5: false },
  { country: 'United States', network: 'United States Cellular Corporation', g2: false, g3: false, lte: true, g5: true },
  { country: 'United States', network: 'Verizon', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'AT&T', g2: false, g3: false, lte: true, g5: true },
  { country: 'United States', network: 'Appalachian', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'Carolina West', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'C-Spire', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'Inland', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'James Valley', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'Nex Tech', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'Pine Belt Cellular', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'PTCI/PanHandle', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'Strata-Snake River', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'United Wireless', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'Viaero', g2: false, g3: false, lte: true, g5: false },
  { country: 'United States', network: 'V-Tel', g2: false, g3: false, lte: true, g5: false },
  { country: 'Vanuatu', network: 'Vodafone Vanuatu', g2: true, g3: true, lte: true, g5: false },
  { country: 'Vietnam', network: 'Mobifone', g2: true, g3: true, lte: true, g5: false },
  { country: 'Vietnam', network: 'Vietnamobile Telecommunications Joint Stock Company', g2: true, g3: true, lte: false, g5: false },
]

export const zone4Countries: ZoneEntry[] = [
  { country: 'Afghanistan', network: 'Etisalat Afghanistan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Afghanistan', network: 'Afghan Wireless Communication Company', g2: true, g3: true, lte: true, g5: false },
  { country: 'Albania', network: 'One Albania sh.a', g2: false, g3: true, lte: true, g5: false },
  { country: 'Algeria', network: 'Ooredoo Algérie', g2: true, g3: true, lte: true, g5: false },
  { country: 'Argentina', network: 'Telecom Argentina S.A.', g2: true, g3: true, lte: true, g5: true },
  { country: 'Bahrain', network: 'Zain Bahrain', g2: true, g3: false, lte: true, g5: false },
  { country: 'Belarus', network: 'Unitary enterprise A1', g2: false, g3: true, lte: false, g5: false },
  { country: 'Belarus', network: 'life:)', g2: false, g3: true, lte: false, g5: false },
  { country: 'Burkina Faso', network: 'AIRTEL BURKINA FASO', g2: true, g3: true, lte: true, g5: false },
  { country: 'Central African Republic', network: 'ORANGE CENTRAFRIQUE', g2: true, g3: true, lte: false, g5: false },
  { country: 'Chad', network: 'CELTEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Congo', network: 'CELTEL (RDC) SPRL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Congo, The Democratic Republic of the', network: 'CELTEL CONGO', g2: true, g3: true, lte: true, g5: false },
  { country: 'Congo, The Democratic Republic of the', network: 'Africell DRC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Côte d’Ivoire', network: 'ORANGE COTE D`IVOIRE', g2: true, g3: true, lte: true, g5: false },
  { country: 'Dominican Republic', network: 'Altice Dominican Republic', g2: true, g3: true, lte: true, g5: false },
  { country: 'Egypt', network: 'Etisalat Egypt', g2: true, g3: true, lte: true, g5: false },
  { country: 'Egypt', network: 'Vodafone Egypt', g2: true, g3: true, lte: true, g5: false },
  { country: 'Gabon', network: 'CELTEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Georgia', network: 'Magticom Ltd', g2: true, g3: true, lte: true, g5: false },
  { country: 'Greenland', network: 'TELEGREENLAND', g2: false, g3: false, lte: true, g5: false },
  { country: 'Guinea*', network: 'Areeba Guinée S.A.', g2: true, g3: true, lte: false, g5: false },
  { country: 'Hong Kong, SAR China', network: 'Hong Kong Telecommunications (HKT) Limited', g2: true, g3: true, lte: true, g5: true },
  { country: 'Hong Kong, SAR China', network: 'China Mobile Hong Kong Company Limited', g2: false, g3: true, lte: true, g5: false },
  { country: 'Iraq', network: 'Asiacell Communications PJSC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Iraq', network: 'Zain Iraq', g2: true, g3: true, lte: true, g5: false },
  { country: 'Israel', network: 'Partner Communications Company Ltd.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Jordan', network: 'Umniah Mobile Company', g2: false, g3: true, lte: true, g5: false },
  { country: 'Jordan', network: 'Orange Jordan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Kenya', network: 'KENCELL GSM 900', g2: true, g3: true, lte: true, g5: false },
  { country: 'Kuwait', network: 'Ooredoo Kuwait', g2: true, g3: true, lte: true, g5: false },
  { country: 'Kuwait', network: 'Zain Kuwait', g2: true, g3: true, lte: false, g5: true },
  { country: 'Lao People’s Democratic Republic', network: 'Lao Telecommunication Public Company', g2: true, g3: true, lte: true, g5: true },
  { country: 'Liberia', network: 'CELLCOM', g2: true, g3: true, lte: true, g5: false },
  { country: 'Madagascar', network: 'MADACOM GSM900', g2: true, g3: true, lte: true, g5: false },
  { country: 'Madagascar', network: 'ORANGE MADAGASCAR', g2: false, g3: true, lte: true, g5: false },
  { country: 'Malawi', network: 'CELTELL MALAWI', g2: true, g3: true, lte: true, g5: false },
  { country: 'Malaysia', network: 'Digi Telecommunications Sdn Bhd', g2: true, g3: false, lte: true, g5: false },
  { country: 'Malaysia', network: 'U Mobile Sdn. Bhd.', g2: true, g3: false, lte: true, g5: false },
  { country: 'Mali', network: 'ORANGE MALI SA', g2: true, g3: true, lte: true, g5: false },
  { country: 'Monaco', network: 'Monaco Telecom S.A.M.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Montenegro', network: 'Crnogorski Telekom a.d. Podgorica', g2: true, g3: true, lte: true, g5: true },
  { country: 'Morocco', network: 'Orange Maroc', g2: false, g3: true, lte: true, g5: false },
  { country: 'Morocco', network: 'Maroc Telecom', g2: false, g3: false, lte: false, g5: false },
  { country: 'Niger', network: 'AIRTEL', g2: true, g3: true, lte: false, g5: false },
  { country: 'North Macedonia', network: 'Makedonski Telekom AD - Skopje', g2: true, g3: false, lte: true, g5: false },
  { country: 'Oman', network: 'Ooredoo Oman', g2: true, g3: true, lte: true, g5: false },
  { country: 'Papua New Guinea', network: 'Vodafone PNG', g2: false, g3: false, lte: true, g5: false },
  { country: 'Peru', network: 'Entel Peru', g2: true, g3: true, lte: true, g5: false },
  { country: 'Qatar', network: 'Ooredoo Qatar', g2: false, g3: true, lte: false, g5: false },
  { country: 'Rwanda', network: 'TIGO RWANDA', g2: true, g3: true, lte: true, g5: false },
  { country: 'Rwanda', network: 'AIRTEL LIMITED', g2: true, g3: true, lte: false, g5: false },
  { country: 'Senegal', network: 'SONATEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Serbia', network: 'Yettel Serbia', g2: true, g3: true, lte: true, g5: false },
  { country: 'Seychelles', network: 'TELECOM SEYCHELLES', g2: true, g3: true, lte: true, g5: false },
  { country: 'Sierra Leone', network: 'CELTEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Sierra Leone', network: 'AFRICELL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Singapore', network: 'StarHub Mobile Pte Ltd', g2: false, g3: true, lte: true, g5: true },
  { country: 'South Sudan (Republic of)', network: 'Zain South Sudan', g2: true, g3: true, lte: false, g5: false },
  { country: 'Sri Lanka', network: 'Airtel Sri Lanka', g2: true, g3: true, lte: false, g5: false },
  { country: 'Sri Lanka', network: 'Dialog Axiata Plc', g2: true, g3: false, lte: true, g5: false },
  { country: 'Taiwan, Province of China', network: 'Chunghwa Telecom', g2: false, g3: false, lte: true, g5: false },
  { country: 'Tajikistan', network: 'ZET-MOBILE', g2: true, g3: true, lte: true, g5: false },
  { country: 'Tunisia', network: 'Ooredoo Tunisie SA', g2: true, g3: true, lte: true, g5: false },
  { country: 'Uganda', network: 'CELTEL LTD GSM 900', g2: true, g3: true, lte: true, g5: false },
  { country: 'Uruguay', network: 'Antel', g2: true, g3: true, lte: true, g5: false },
  { country: 'Uzbekistan', network: 'COSCOM', g2: true, g3: true, lte: true, g5: true },
  { country: 'Zambia', network: 'CELTEL ZAMBIA', g2: true, g3: true, lte: true, g5: false },
]

export const zone5Countries: ZoneEntry[] = [
  { country: 'Afghanistan', network: 'Telecom Development Company Afghanistan Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Algeria', network: 'ATM Mobilis', g2: true, g3: true, lte: true, g5: false },
  { country: 'Argentina', network: 'Movistar Argentina', g2: true, g3: true, lte: true, g5: false },
  { country: 'Armenia', network: 'Team Telecom  Armenia', g2: true, g3: true, lte: true, g5: false },
  { country: 'Armenia', network: 'Viva-MTS', g2: true, g3: true, lte: true, g5: true },
  { country: 'Azerbaijan', network: 'Azercell Telecom LLC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Azerbaijan', network: 'Bakcell Limited Liable Company', g2: true, g3: true, lte: true, g5: false },
  { country: 'Bahrain', network: 'stc Bahrain', g2: true, g3: true, lte: true, g5: true },
  { country: 'Belize', network: 'DigiCell', g2: true, g3: true, lte: true, g5: false },
  { country: 'Benin', network: 'SBIN', g2: true, g3: true, lte: true, g5: false },
  { country: 'Bermuda', network: 'One Communications', g2: true, g3: true, lte: true, g5: false },
  { country: 'Bolivia (Plurinational State of)', network: 'Tigo Bolivia', g2: true, g3: true, lte: true, g5: false },
  { country: 'Botswana', network: 'Mascom Wireless (Pty) Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Botswana', network: 'Orange Botswana', g2: true, g3: true, lte: true, g5: false },
  { country: 'Cambodia', network: 'Smart Axiata', g2: true, g3: false, lte: true, g5: false },
  { country: 'Cameroon', network: 'MTN CAMEROON LTD', g2: true, g3: true, lte: true, g5: false },
  { country: 'Canada', network: 'TELUS Communications Inc.', g2: true, g3: true, lte: true, g5: true },
  { country: 'Canada', network: 'Bell Mobility Inc.', g2: false, g3: true, lte: true, g5: true },
  { country: 'Canada', network: 'Rogers Communications Canada Inc.', g2: true, g3: true, lte: true, g5: true },
  { country: 'Cape Verde', network: 'CVMOVEL TELECOM', g2: true, g3: true, lte: true, g5: false },
  { country: 'Cape Verde', network: 'T PIU', g2: true, g3: true, lte: true, g5: false },
  { country: 'Chile', network: 'Entel PCS Telecomunicaciones S.A.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Chile', network: 'Movistar Chile', g2: true, g3: true, lte: true, g5: false },
  { country: 'Colombia', network: 'Tigo Colombia', g2: false, g3: true, lte: true, g5: false },
  { country: 'Colombia', network: 'Movistar Colombia', g2: true, g3: true, lte: true, g5: false },
  { country: 'Congo', network: 'LIBERTIS TELECOM', g2: true, g3: true, lte: true, g5: false },
  { country: 'Costa Rica', network: 'ice', g2: true, g3: true, lte: true, g5: false },
  { country: 'Costa Rica', network: 'LIBERTY COSTA RICA', g2: true, g3: true, lte: true, g5: false },
  { country: 'Côte d’Ivoire', network: 'MTN CI', g2: true, g3: true, lte: true, g5: false },
  { country: 'Cuba', network: 'C_COM', g2: true, g3: true, lte: true, g5: false },
  { country: 'Dominican Republic', network: 'viva', g2: true, g3: true, lte: false, g5: false },
  { country: 'Ecuador', network: 'Movistar Ecuador', g2: true, g3: true, lte: true, g5: false },
  { country: 'Egypt', network: 'Orange Egypt', g2: true, g3: false, lte: true, g5: false },
  { country: 'El Salvador', network: 'Tigo El Salvador', g2: true, g3: true, lte: true, g5: false },
  { country: 'El Salvador', network: 'Movistar El Salvador', g2: true, g3: true, lte: true, g5: false },
  { country: 'Gambia', network: 'AFRICELL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Ghana', network: 'Vodafone Ghana', g2: true, g3: true, lte: true, g5: false },
  { country: 'Ghana', network: 'MTN Ghana', g2: true, g3: true, lte: false, g5: false },
  { country: 'Guadeloupe', network: 'Orange French West indies', g2: true, g3: false, lte: false, g5: false },
  { country: 'Guam', network: 'IT&E', g2: true, g3: true, lte: true, g5: false },
  { country: 'Guam', network: 'Teleguam Holdings, LLC', g2: false, g3: true, lte: true, g5: false },
  { country: 'Guatemala', network: 'Tigo Guatemala', g2: true, g3: true, lte: true, g5: false },
  { country: 'Guinea-Bissau', network: 'MTN BISSAU', g2: false, g3: true, lte: true, g5: false },
  { country: 'Guyana', network: 'GTT', g2: true, g3: true, lte: true, g5: false },
  { country: 'Honduras', network: 'Tigo Honduras', g2: true, g3: true, lte: true, g5: false },
  { country: 'Hong Kong, SAR China', network: 'SmarTone Mobile Communications Limited', g2: false, g3: true, lte: true, g5: true },
  { country: 'Iraq', network: 'Korek Telecom Company', g2: true, g3: true, lte: true, g5: false },
  { country: 'Jersey', network: 'JT', g2: false, g3: true, lte: true, g5: false },
  { country: 'Kazakhstan', network: 'Kcell JSC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Kazakhstan', network: 'Tele2 Kazakhstan', g2: true, g3: true, lte: true, g5: false },
  { country: 'Kenya', network: 'SAFARICOM', g2: true, g3: true, lte: true, g5: true },
  { country: 'Kingdom of Eswatini', network: 'Swazi MTN Limited', g2: true, g3: true, lte: false, g5: false },
  { country: 'Kyrgyzstan', network: 'Mega', g2: true, g3: true, lte: true, g5: false },
  { country: 'Liberia', network: 'LONESTARCELL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Libya', network: 'Libyana Mobile Phone', g2: true, g3: true, lte: false, g5: false },
  { country: 'Malaysia', network: 'Maxis Broadband Sdn. Bhd.', g2: true, g3: false, lte: true, g5: false },
  { country: 'Mauritius', network: 'CELLPLUS', g2: true, g3: true, lte: true, g5: true },
  { country: 'Mauritius', network: 'GSM 900 EMTEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Mexico', network: 'Movistar Mexico', g2: false, g3: true, lte: true, g5: false },
  { country: 'Mongolia', network: 'Skytel LLC', g2: true, g3: true, lte: false, g5: false },
  { country: 'Namibia', network: 'POWERCOM', g2: false, g3: true, lte: false, g5: false },
  { country: 'Nepal', network: 'Nepal Telecom', g2: true, g3: true, lte: true, g5: false },
  { country: 'Nicaragua', network: 'Tigo Nicaragua', g2: true, g3: true, lte: true, g5: false },
  { country: 'Panama', network: 'Cable & Wireless Panamá, S.A.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Panama', network: 'Tigo Panamá', g2: true, g3: true, lte: true, g5: false },
  { country: 'Paraguay', network: 'Tigo Paraguay', g2: true, g3: true, lte: true, g5: false },
  { country: 'Peru', network: 'Movistar Peru', g2: true, g3: true, lte: true, g5: false },
  { country: 'Philippines', network: 'Smart Philippines', g2: true, g3: true, lte: true, g5: true },
  { country: 'Rwanda', network: 'MTN RWANDACELL', g2: false, g3: true, lte: true, g5: false },
  { country: 'South Africa', network: 'MTN South Africa', g2: true, g3: true, lte: true, g5: false },
  { country: 'Suriname', network: 'DIGICEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Taiwan, Province of China', network: 'Far EasTone Telecommunications Co Ltd (TWNFE)', g2: true, g3: false, lte: true, g5: true },
  { country: 'Tajikistan', network: 'Indigo Tajikistan CJSC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Tanzania, United Republic of', network: 'Airtel Tanzania', g2: true, g3: true, lte: true, g5: false },
  { country: 'Trinidad and Tobago', network: 'Telecommunications Services of Trinidad and Tobago Ltd', g2: true, g3: true, lte: false, g5: false },
  { country: 'Uganda', network: 'MTN UGANDA GSM 900', g2: false, g3: true, lte: true, g5: false },
  { country: 'United Arab Emirates', network: 'du', g2: true, g3: true, lte: true, g5: true },
  { country: 'Uruguay', network: 'Movistar Uruguay', g2: true, g3: true, lte: true, g5: false },
  { country: 'Uzbekistan', network: 'DAEWOO UNITEL', g2: true, g3: true, lte: true, g5: false },
  { country: 'Yemen', network: 'YOU Yemen Oman United Telecom', g2: true, g3: false, lte: false, g5: false },
  { country: 'Zambia', network: 'CELTEL ZAMBIA LIMITED', g2: false, g3: true, lte: true, g5: false },
]

export const zone6Countries: ZoneEntry[] = [
  { country: 'Armenia', network: 'Ucom', g2: true, g3: true, lte: true, g5: false },
  { country: 'Aruba', network: 'SETAR', g2: true, g3: true, lte: true, g5: false },
  { country: 'Bahamas', network: 'The Bahamas Telecommunications Company Ltd.', g2: true, g3: true, lte: true, g5: false },
  { country: 'Bahamas', network: 'Aliv', g2: true, g3: true, lte: true, g5: false },
  { country: 'British Virgin Islands', network: 'Digicel British Virgin Islands', g2: true, g3: true, lte: true, g5: false },
  { country: 'Brunei', network: 'UNN', g2: true, g3: true, lte: true, g5: false },
  { country: 'Chad', network: 'MILLICOM CHAD', g2: true, g3: true, lte: true, g5: false },
  { country: 'El Salvador', network: 'Digicel El Salvador', g2: true, g3: true, lte: true, g5: false },
  { country: 'Equatorial Guinea', network: 'GETESA', g2: false, g3: false, lte: false, g5: false },
  { country: 'Gabon', network: 'LIBERTIS', g2: true, g3: true, lte: true, g5: false },
  { country: 'Georgia', network: 'Silknet JSC', g2: true, g3: true, lte: true, g5: false },
  { country: 'Guyana', network: 'Digicel Guyana', g2: true, g3: true, lte: true, g5: false },
  { country: 'Haiti', network: 'Viettel Group', g2: true, g3: false, lte: false, g5: false },
  { country: 'Iran (the Islamic Republic of)', network: 'TCI', g2: true, g3: true, lte: true, g5: false },
  { country: 'Jamaica', network: 'Digicel (Jamaica) Limited', g2: false, g3: true, lte: true, g5: false },
  { country: 'Japan', network: 'NTT DOCOMO, Inc.', g2: false, g3: true, lte: true, g5: false },
  { country: 'Kingdom of Eswatini', network: 'Swazi Mobile Limited', g2: false, g3: false, lte: false, g5: false },
  { country: 'Kuwait', network: 'stc Kuwait', g2: true, g3: true, lte: true, g5: true },
  { country: 'Lao People’s Democratic Republic', network: 'Viettel Group', g2: true, g3: false, lte: false, g5: false },
  { country: 'Lebanon', network: 'Alfa', g2: true, g3: true, lte: true, g5: false },
  { country: 'Lebanon', network: 'Touch', g2: true, g3: true, lte: true, g5: false },
  { country: 'Libya', network: 'Al Madar Al Jadid', g2: true, g3: true, lte: false, g5: false },
  { country: 'Mali', network: 'Malitel', g2: true, g3: true, lte: true, g5: false },
  { country: 'Mauritius', network: 'MTML', g2: true, g3: true, lte: true, g5: false },
  { country: 'Monaco', network: 'Monaco Telecom S.A.M.', g2: true, g3: true, lte: true, g5: true },
  { country: 'Mongolia', network: 'Unitel LLC', g2: true, g3: true, lte: true, g5: false },
  { country: 'New Zealand', network: 'Two Degrees Networks Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Pakistan', network: 'Jazz', g2: true, g3: true, lte: false, g5: false },
  { country: 'Peru', network: 'Viettel Group', g2: true, g3: false, lte: false, g5: false },
  { country: 'Samoa', network: 'Vodafone Samoa', g2: true, g3: true, lte: true, g5: false },
  { country: 'Saudi Arabia', network: 'Zain Saudi Arabia', g2: true, g3: true, lte: true, g5: true },
  { country: 'Sri Lanka', network: 'Mobitel (Pvt) Limited', g2: true, g3: true, lte: true, g5: false },
  { country: 'Tanzania, United Republic of', network: 'Tigo Tanzania', g2: true, g3: true, lte: false, g5: false },
  { country: 'Thailand', network: 'True Move H Universal Communication Co., Ltd (THADT)', g2: false, g3: true, lte: true, g5: false },
  { country: 'Timor-Leste', network: 'Telkomcel', g2: true, g3: true, lte: false, g5: false },
  { country: 'Trinidad and Tobago', network: 'Digicel Trinidad and Tobago', g2: true, g3: true, lte: true, g5: false },
  { country: 'Türkiye', network: 'TT Mobil Iletisim Hizmetleri A.S.', g2: true, g3: true, lte: true, g5: false },
  { country: 'United Arab Emirates', network: 'Etisalat United Arab Emirates', g2: true, g3: true, lte: true, g5: true },
  { country: 'Yemen', network: 'Yemen Mobile Phone Company - Sabafon', g2: true, g3: false, lte: false, g5: false },
]

export const countryZoneMap: Record<string, string[]> = {
  'Afghanistan': ['zone4', 'zone5'],
  'Albania': ['zone4'],
  'Algeria': ['zone2', 'zone4', 'zone5'],
  'Andorra': ['zone2'],
  'Argentina': ['zone2', 'zone4', 'zone5'],
  'Armenia': ['zone5', 'zone6'],
  'Aruba': ['zone6'],
  'Australia': ['zone2', 'zone3'],
  'Austria': ['multinet', 'zone1'],
  'Azerbaijan': ['zone5'],
  'Bahamas': ['zone6'],
  'Bahrain': ['zone4', 'zone5'],
  'Bangladesh': ['zone2'],
  'Belarus': ['zone4'],
  'Belgium': ['multinet', 'zone1'],
  'Belize': ['zone5'],
  'Benin': ['zone5'],
  'Bermuda': ['zone5'],
  'Bolivia (Plurinational State of)': ['zone5'],
  'Bosnia and Herzegovina': ['zone3'],
  'Botswana': ['zone5'],
  'British Virgin Islands': ['zone6'],
  'Brunei': ['zone6'],
  'Bulgaria': ['multinet', 'zone1'],
  'Burkina Faso': ['zone4'],
  'Cambodia': ['zone5'],
  'Cameroon': ['zone3', 'zone5'],
  'Canada': ['zone5'],
  'Cape Verde': ['zone5'],
  'Central African Republic': ['zone4'],
  'Chad': ['zone4', 'zone6'],
  'Chile': ['zone2', 'zone5'],
  'China': ['zone2'],
  'Colombia': ['zone2', 'zone5'],
  'Congo': ['zone4', 'zone5'],
  'Congo, The Democratic Republic of the': ['zone4'],
  'Costa Rica': ['zone2', 'zone5'],
  'Croatia': ['multinet', 'zone1'],
  'Cuba': ['zone5'],
  'Cyprus': ['multinet', 'zone1'],
  'Czechia': ['multinet', 'zone1'],
  'Côte d’Ivoire': ['zone4', 'zone5'],
  'Denmark': ['multinet', 'zone1'],
  'Dominican Republic': ['zone2', 'zone4', 'zone5'],
  'Ecuador': ['zone2', 'zone5'],
  'Egypt': ['zone4', 'zone5'],
  'El Salvador': ['zone2', 'zone5', 'zone6'],
  'Equatorial Guinea': ['zone6'],
  'Estonia': ['multinet', 'zone1'],
  'Faroe Islands': ['zone2'],
  'Fiji': ['zone2', 'zone3'],
  'Finland': ['multinet', 'zone1'],
  'France': ['zone2', 'zone3'],
  'Gabon': ['zone4', 'zone6'],
  'Gambia': ['zone5'],
  'Georgia': ['zone3', 'zone4', 'zone6'],
  'Germany': ['multinet', 'zone1'],
  'Ghana': ['zone5'],
  'Gibraltar': ['multinet', 'zone1'],
  'Greece': ['multinet', 'zone1'],
  'Greenland': ['zone4'],
  'Guadeloupe': ['zone2', 'zone3', 'zone5'],
  'Guam': ['zone5'],
  'Guatemala': ['zone2', 'zone5'],
  'Guinea*': ['zone4'],
  'Guinea-Bissau': ['zone5'],
  'Guyana': ['zone5', 'zone6'],
  'Haiti': ['zone6'],
  'Honduras': ['zone2', 'zone5'],
  'Hong Kong, SAR China': ['zone3', 'zone4', 'zone5'],
  'Hungary': ['multinet', 'zone1'],
  'Iceland': ['zone2', 'zone3'],
  'India*': ['zone2', 'zone3'],
  'Indonesia': ['zone2', 'zone3'],
  'Iran (the Islamic Republic of)': ['zone6'],
  'Iraq': ['zone4', 'zone5'],
  'Ireland': ['multinet', 'zone1'],
  'Israel': ['zone3', 'zone4'],
  'Italy': ['multinet', 'zone1'],
  'Jamaica': ['zone6'],
  'Japan': ['zone2', 'zone3', 'zone6'],
  'Jersey': ['zone5'],
  'Jordan': ['zone3', 'zone4'],
  'Kazakhstan': ['zone2', 'zone5'],
  'Kenya': ['zone4', 'zone5'],
  'Kingdom of Eswatini': ['zone5', 'zone6'],
  'Korea, Republic of': ['zone3'],
  'Kosovo': ['zone3'],
  'Kuwait': ['zone4', 'zone6'],
  'Kyrgyzstan': ['zone2', 'zone5'],
  'Lao People’s Democratic Republic': ['zone4', 'zone6'],
  'Latvia': ['multinet', 'zone1'],
  'Lebanon': ['zone6'],
  'Lesotho': ['zone3'],
  'Liberia': ['zone4', 'zone5'],
  'Libya': ['zone5', 'zone6'],
  'Liechtenstein': ['zone2'],
  'Lithuania': ['multinet', 'zone1'],
  'Luxembourg': ['multinet', 'zone1'],
  'Macao, SAR China': ['zone2'],
  'Madagascar': ['zone4'],
  'Malawi': ['zone4'],
  'Malaysia': ['zone3', 'zone4', 'zone5'],
  'Mali': ['zone4', 'zone6'],
  'Malta': ['multinet', 'zone1'],
  'Martinique': ['zone3'],
  'Mauritius': ['zone5', 'zone6'],
  'Mexico': ['zone2', 'zone3', 'zone5'],
  'Moldova, Republic of': ['zone2', 'zone3'],
  'Monaco': ['zone4', 'zone6'],
  'Mongolia': ['zone5', 'zone6'],
  'Montenegro': ['zone3', 'zone4'],
  'Morocco': ['zone4'],
  'Mozambique': ['zone3'],
  'Myanmar': ['zone3'],
  'Namibia': ['zone5'],
  'Nepal': ['zone5'],
  'Netherlands': ['multinet', 'zone1'],
  'New Zealand': ['zone2', 'zone6'],
  'Nicaragua': ['zone2', 'zone5'],
  'Niger': ['zone4'],
  'Nigeria': ['zone3'],
  'North Macedonia': ['zone2', 'zone4'],
  'Norway': ['multinet', 'zone1'],
  'Oman': ['zone2', 'zone4'],
  'Pakistan': ['zone2', 'zone6'],
  'Panama': ['zone5'],
  'Papua New Guinea': ['zone3', 'zone4'],
  'Paraguay': ['zone2', 'zone5'],
  'Peru': ['zone2', 'zone4', 'zone5', 'zone6'],
  'Philippines': ['zone2', 'zone5'],
  'Poland': ['multinet', 'zone1'],
  'Portugal': ['multinet', 'zone1'],
  'Puerto Rico': ['zone2'],
  'Qatar': ['zone4'],
  'Romania': ['multinet', 'zone1'],
  'Russian Federation': ['zone3'],
  'Rwanda': ['zone4', 'zone5'],
  'Réunion': ['zone2'],
  'Samoa': ['zone2', 'zone6'],
  'Saudi Arabia': ['zone6'],
  'Senegal': ['zone4'],
  'Serbia': ['zone2', 'zone3', 'zone4'],
  'Seychelles': ['zone4'],
  'Sierra Leone': ['zone4'],
  'Singapore': ['zone2', 'zone4'],
  'Slovakia': ['multinet', 'zone1'],
  'Slovenia': ['multinet', 'zone1'],
  'South Africa': ['zone3', 'zone5'],
  'South Sudan (Republic of)': ['zone4'],
  'Spain': ['multinet', 'zone1'],
  'Sri Lanka': ['zone3', 'zone4', 'zone6'],
  'Suriname': ['zone5'],
  'Sweden': ['multinet', 'zone1'],
  'Switzerland': ['zone2'],
  'Taiwan, Province of China': ['zone4', 'zone5'],
  'Tajikistan': ['zone4', 'zone5'],
  'Tanzania, United Republic of': ['zone3', 'zone5', 'zone6'],
  'Thailand': ['zone2', 'zone3', 'zone6'],
  'Timor-Leste': ['zone6'],
  'Tonga': ['zone2', 'zone3'],
  'Trinidad and Tobago': ['zone5', 'zone6'],
  'Tunisia': ['zone3', 'zone4'],
  'Turkey*': ['zone2', 'zone3'],
  'Türkiye': ['zone6'],
  'Uganda': ['zone4', 'zone5'],
  'Ukraine': ['zone2'],
  'United Arab Emirates': ['zone5', 'zone6'],
  'United Kingdom': ['multinet', 'zone1'],
  'United States': ['zone3'],
  'Uruguay': ['zone2', 'zone4', 'zone5'],
  'Uzbekistan': ['zone4', 'zone5'],
  'Vanuatu': ['zone2', 'zone3'],
  'Vietnam': ['zone3'],
  'Yemen': ['zone5', 'zone6'],
  'Zambia': ['zone4', 'zone5'],
}

export const allRoamingCountries: string[] = ["Afghanistan", "Albania", "Algeria", "Andorra", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bolivia (Plurinational State of)", "Bosnia and Herzegovina", "Botswana", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Congo", "Congo, The Democratic Republic of the", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia", "C\u00f4te d\u2019Ivoire", "Denmark", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Faroe Islands", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Guadeloupe", "Guam", "Guatemala", "Guinea*", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong, SAR China", "Hungary", "Iceland", "India*", "Indonesia", "Iran (the Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kingdom of Eswatini", "Korea, Republic of", "Kosovo", "Kuwait", "Kyrgyzstan", "Lao People\u2019s Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao, SAR China", "Madagascar", "Malawi", "Malaysia", "Mali", "Malta", "Martinique", "Mauritius", "Mexico", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway", "Oman", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russian Federation", "Rwanda", "R\u00e9union", "Samoa", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Sudan (Republic of)", "Spain", "Sri Lanka", "Suriname", "Sweden", "Switzerland", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey*", "T\u00fcrkiye", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vietnam", "Yemen", "Zambia"]

export const zoneLabels: Record<string, string> = {
  multinet: 'Euro MultiNet Sim',
  zone1: 'World MultiNet Zone 1',
  zone2: 'World MultiNet Zone 2',
  zone3: 'World MultiNet Zone 3',
  zone4: 'World MultiNet Zone 4',
  zone5: 'World MultiNet Zone 5',
  zone6: 'World MultiNet Zone 6',
}

export const zoneNetworkType: Record<string, string> = {
  multinet: 'roaming_multinet',
  zone1: 'roaming_zone1',
  zone2: 'roaming_zone2',
  zone3: 'roaming_zone3',
  zone4: 'roaming_zone4',
  zone5: 'roaming_zone5',
  zone6: 'roaming_zone6',
}
